const INITIAL_STATE = {
  listGrupoFisicoPluviometro: [],
  listControladorPluviometro: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'GRUPO_FISICO_PLUVIOMETRO_FETCHED':
      return { ...state, listGrupoFisicoPluviometro: action.payload.data };
    case 'CONTROLADOR_CONF_PLUVIOMETRO_LIST_FETCHED':
      return { ...state, listControladorPluviometro: action.payload.data };
    default:
      return state;
  }
};
